import { Component, Inject, HostListener } from '@angular/core';
import { LoginService } from './services/login.service';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';




@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})




export class AppComponent {
  titleService: any;
  sidebarOpen = false;

  //@HostListener('window:popstate', ['$event'])
  //onPopState(event) {
  //  this.authenticated = false;
  //}


  public constructor(@Inject(Title) titleService: Title, @Inject(Router) _router: Router) {
    this.titleService = titleService.setTitle('EDU Interactive Partners');
    this.router = _router;
  }

  

  router: Router;
  authenticated: string = sessionStorage.getItem('intcontId');
  regShow: boolean = false;
  passReset: boolean = false;


  ngOnInit() {
    console.log(window.location.href);
    if (window.location.href.indexOf('passwordreset') > 0) {
      this.authenticated = '0';
      this.regShow = false;
      this.passReset = true;
    }
  }


  loggedInHandler(loggedIn: string) {
    this.authenticated = loggedIn;
  }

  showRegHandler(isReg: boolean) {
    this.regShow = isReg;
  }


  toggleSideBar(openSideBar: boolean) {
    this.sidebarOpen = openSideBar;
  }

  passwordReset(passReset: boolean) {
    this.passReset = passReset;
  }

}
